import { render, staticRenderFns } from "./ProjectPlatformGoogleBusinessMessages.vue?vue&type=template&id=2ba62d3c"
import script from "./ProjectPlatformGoogleBusinessMessages.vue?vue&type=script&lang=ts"
export * from "./ProjectPlatformGoogleBusinessMessages.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports